import * as moment from 'moment';
import { Business } from "../trucks/truck.model";
import { GpsLog } from "./gps-log.model";
import { Moment } from 'moment';

export class GpsLogItem {
    business: Business;
    computerType: string;
    deviceId: string;
    distanceFromCenter: number;
    ipAddress: string;
    latitude: number;
    longitude: number;
    softwareVersion: number;
    speed: number;
    timestamp: Moment;
    truckNumber: string;

    constructor(log: GpsLog) {
        this.business = Business[log.business];
        this.computerType = log.computerType;
        this.deviceId = log.deviceId;
        this.distanceFromCenter = log.distanceFromCenter;
        this.ipAddress = log.ipAddress;
        this.latitude = log.latitude;
        this.longitude = log.longitude;
        this.softwareVersion = log.softwareVersion;
        this.speed = log.speed;
        this.timestamp = moment.parseZone(log.timestamp);
        this.truckNumber = log.truckNumber;
    }
}
